import Router from "router";
import "../src/assets/main.css"
import "../src/App.css"

function App() {
  return (
    <Router />
  );
}

export default App;
